import axios from 'axios';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../Firebase Functions/firebase';

const quickbaseApi = axios.create({
  baseURL: 'https://api.quickbase.com/v1',
  headers: {
    'QB-Realm-Hostname': process.env.REACT_APP_QB_REALM_HOSTNAME,
    'Authorization': `QB-USER-TOKEN ${process.env.REACT_APP_QB_API_KEY}`,
    'Content-Type': 'application/json'
  }
});

export const UpdateQuickBaseIncidentReport = async (incidentId, pdfBase64, existingRecordId = null) => {
  try {
    // ✅ Step 1: Get incident report data
    const docRef = doc(db, 'incidentReports', incidentId);
    const docSnap = await getDoc(docRef);

    if (!docSnap.exists()) {
      throw new Error('Incident document not found.');
    }

    const incidentData = docSnap.data();

    // ✅ Extract values for fields
    const market = incidentData.employee?.market || 'N/A';
    const incidentDate = incidentData.occurrence?.injuryDate || '';
    const employeeName = incidentData.employee?.name || 'Unknown';

    // ✅ Build record payload
    const record = {
      9: { value: employeeName },
      8: { value: market },
      6: { value: incidentDate },
      7: {
        value: {
          fileName: `IncidentReport_${incidentId}.pdf`,
          data: pdfBase64 // <-- already clean
        }
      },
      12: { value: incidentId }
    };

    if (existingRecordId) {
      record[3] = { value: existingRecordId }; // Record ID# for updates
    }

    const payload = {
      to: 'buz6rhchu', // Replace with your actual table ID
      data: [record]
    };

    const response = await quickbaseApi.post('/records', payload);
    console.log('✅ QuickBase incident report uploaded:', response.data);

    const recordId = response.data?.metadata?.createdRecordIds?.[0] || response.data?.metadata?.updatedRecordIds?.[0];

    return { data: response.data, recordId };

  } catch (error) {
    const message = error.response?.data?.message || error.message || 'QuickBase update failed';
    console.error('❌ QuickBase update failed:', message);
    throw new Error(message);
  }
};

export const isIncidentReportCompleted = async (incidentId) => {
  try {
    const queryPayload = {
      from: 'buz6rhchu',
      select: [17],
      where: `{12.EX.'${incidentId}'}`,
    };

    const response = await quickbaseApi.post('/records/query', queryPayload);
    const record = response.data?.data?.[0];
    return record?.[17]?.value === true;
  } catch (error) {
    console.error('❌ Failed to check QuickBase completion:', error);
    return false;
  }
};

